import tools from 'tools';
import FastOrder from 'component/FastOrder';

export default class ProductListItemCollection {
    constructor() {
        this.itemClass = 'product-list-item';
        this.itemSelector = '.' + this.itemClass;

        // Event is here, because it must not reinitialize
        $(document).on('custom:ProductListItemCollection.reinit', this.init.bind(this));
        this.init();
    }

    /**
     * Can be triggered by external event
     */
    init() {
        this.applyLayoutModifications();
        this.bindEvents();
        this.checkBasketStatus();
    }

    /**
     * Modifications because of weird seo requirements
     */
    applyLayoutModifications() {
    }

    bindEvents() {
        $('.product-list-item__buy-button').off('click.collection').on('click.collection', this.onBuyButtonClick.bind(this));
        $('.product-list-item__fast-order-button').off('click.collection').on('click.collection', this.onFastOrderButtonClick.bind(this));

        $('.product-list-item__plus').on('click', this.onQuantityIncrease.bind(this));
        $('.product-list-item__minus').on('click', this.onQuantityDeacrease.bind(this));
        //$('.product-list-item__quick-view').off('click.collection').on('click.collection', this.onQuickViewClick.bind(this));
    }

    onQuantityIncrease(e) {
        const $el = this.getItemNodeFromEvent(e);
        const $input = $el.find('[name="quantity"]');
        $input.val(Number($input.val()) + 1);
    }

    onQuantityDeacrease(e) {
        const $el = this.getItemNodeFromEvent(e);
        console.log($el)
        const $input = $el.find('[name="quantity"]');
        if ($input.val() > 1) {
            $input.val(Number($input.val()) - 1);
        }
    }

    checkBasketStatus() {
        if (!(typeof app == 'object' && Array.isArray(app.basketProductIds))) {
            return;
        }

        app.basketProductIds.forEach((id) => {
            this.markAsInBasket(id);
        });
    }

    getItemNodeFromEvent(e) {
        return $(e.currentTarget).closest(this.itemSelector);
    }

    getItemNodeById(id) {
        return $(this.itemSelector + '[data-id="' + id + '"]');
    }

    markAsInBasket(id, withTransition = false) {
        const $el = this.getItemNodeById(id);

        if ($el.length == 0) {
            return;
        }

        // Keep visualization even if the item is already in basket
        /*if ($el.hasClass(this.itemClass + '--in-basket')) {
            return;
        }*/

        $el.addClass(this.itemClass + '--in-basket');


        const $button = $el.find(this.itemSelector + '__buy-button');
        $button.addClass('product-buy-button--in-basket');
        $button.find('.product-buy-button__label').text('В корзине');

        if (withTransition) {
            $button.addClass('product-buy-button--transition');

            setTimeout(() => {
                $button.removeClass('product-buy-button--transition');
            }, 1000);
        }
    }

    onBuyButtonClick(e) {
        e.preventDefault();

        const $el = this.getItemNodeFromEvent(e);
        const productId = $el.attr('data-id');
        let quantity = $el.find('[name="quantity"]').val();

        if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
        }

        $.ajax({
            type: 'POST',
            url: '/local/public/basket.php',
            dataType: 'json',
            data: {
                method: 'add',
                id: productId,
                quantity,
                sessid: app.sessid
            }
        }).done((response) => {
            if (response.status === 'error') {
                alert(response.error);
                return;
            }

            $(document).trigger($.Event('custom:basketUpdate', response));
            this.markAsInBasket(productId, true);
            this.animationFlyToCart($el);
        });
    }

    /**
     * Анимация добавления товара в корзину
     * @param id
     * @return void
     */
    animationFlyToCart($el) {
        if ($el.length == 0) {
            return;
        }
        
        var bascket = $(".header-middle__cart-icon-block");
        var w = $el.width();

        $el = $el.find('img.product-list-item__image').eq(0);

        if(bascket.offset()['top'] == 0 && bascket.offset()['left'] == 0) {
            bascket = $(".mobile-small-basket");
        }

        $el.clone()
            .css({'width' : w / 2,
                'position' : 'absolute',
                'z-index' : '9999',
                top: $el.offset().top,
                left:$el.offset().left})
            .appendTo("body")
            .animate({opacity: 0.05,
                left: bascket.offset()['left'],
                top: bascket.offset()['top'],
                width: 100}, 1000, function() {
                $(this).remove();
            });
    }

    onFastOrderButtonClick(e) {
        e.preventDefault();
        const $el = this.getItemNodeFromEvent(e);
        let price = $el.find(`${this.itemSelector}__price--other ${this.itemSelector}__price-value`).text();
        let priceName = $el.find(`${this.itemSelector}__price--other ${this.itemSelector}__price-name`).text();

        if (!price) {
            price = $el.find(`${this.itemSelector}__price--main ${this.itemSelector}__price-value`).text();
            priceName = $el.find(`${this.itemSelector}__price--main ${this.itemSelector}__price-name`).text();
        }

        new FastOrder({
            product: {
                id: $el.attr('data-id'),
                name: $el.find(`${this.itemSelector}__name-link`).text(),
                image: $el.find(`${this.itemSelector}__image`).attr('src'),
                price,
                priceName,
            }
        });
    }
}
